import { Helmet } from "react-helmet-async";

interface SEOHeadProps {
  title?: string;
  description?: string;
  canonical?: string;
}

const defaults = {
  title: "EVK, Thinkers & Makers | Design, Comunicação, Ativação de Marca, Museus e Centros Interpretativos",
  description: "Estúdio criativo especializado em design, comunicação, ativação de marca, museus, centros interpretativos, exposições temporárias e soluções interativas.",
};

const SEOHead = ({ title, description, canonical }: SEOHeadProps) => (
  <Helmet>
    <title>{title ?? defaults.title}</title>
    <meta name="description" content={description ?? defaults.description} />
    {canonical && <link rel="canonical" href={canonical} />}
    <meta property="og:title" content={title ?? defaults.title} />
    <meta property="og:description" content={description ?? defaults.description} />
  </Helmet>
);

export default SEOHead;
